/**
 * Used to provide routing support for either EntitiesStorm or LocationEdit
 *
 * Dan Pomeroy (dp@yext.com)
 */
goog.provide('yext.scheduledupdates.routes');

goog.require('yext.storm.routesDEPRECATED');

yext.scheduledupdates.routes = yext.storm.routesDEPRECATED.EntityScheduledUpdates;

yext.scheduledupdates.routes.init = function() {
  yext.scheduledupdates.routes = yext.storm.routesDEPRECATED.EntityScheduledUpdates;
};
